import { createSlice } from "@reduxjs/toolkit";

const initialState= {
    sops: null,
}

const adminMasterSOPSlice = createSlice({
    name: "adminmastersops",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
         .addCase('LOGOUT', (state) => {
            Object.assign(state, initialState);
         })
    },
    reducers:{
        storeSopDocuments: (state, action) => {
            state.sops= action.payload;
        },
        addSopDocumentToStore: (state, action) => {
            let docs= state.sops&&state.sops.records;
            docs.records= [...docs.records, action.payload]
            state.sops= {...state.documents, records: docs};
        },
        editSopDocumentInStore: (state, action) => {
            let docs= state.sops&&state.sops.records;
            let updatedDocs= docs.map((doc)=>{
                if(action.payload && doc.id === action.payload.id){
                    return action.payload
                }else{
                    return doc
                }
            });
            state.sops= {...state.sops, records: updatedDocs};
        },
        clearSopDocumentStore: (state) => {
            state.sops= null
        }
    }
})

export const { storeSopDocuments, addSopDocumentToStore, editSopDocumentInStore, clearSopDocumentStore } = adminMasterSOPSlice.actions
export default adminMasterSOPSlice.reducer